// extracted by mini-css-extract-plugin
module.exports = {"quotas-inventory-switch":"quotas_quotas-inventory-switch__2WHTm"};